import React, { useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from '../../common/react-redux-hooks';
import CacGridData from '../CacGridData';
import * as cacActions from '../../../actions/cacActions';
import PortalModal from '../../common/Modal/PortalModal';
import GenericButton from '../../common/GenericButton';
import ClusterModelPerfBlock from './ClusterModelPerfBlock';
import { INSUFFICIENT_DATA_MODAL_TEXT, CAC_MODULE_TITLE, HANDLE_CLUSTER_BY_SWITCH_EVENT,
  HANDLE_CHANGE_CLUSTER_SIZE,
  ADD_TO_PASSIVE_EVENT, SHOW_HIDE_DATAPOINT_EVENT, CAC_CLUSTER_SAVE_POPUP_TITLE,
  CAC_CLUSTER_ALREADY_USED_NAME, SAVE_SOLUTION_BTN_TITLE, CAC_CLUSTER_EMPTY_NAME  } from '../CacConstants';
import ClusterRespondentsBlock from './ClusterRespondentsBlock';
import CacSwitchPanel from '../CacSwitchPanel';
import { getApiRequestParameter } from '../../../util/cacUtils';
import CorrAxisSelectBlock from '../Correspondence/CorrAxisSelectBlock';
import TempClusterControlPanel  from "./TempClusterControlPanel";

function ClusterLeftContentGrid(props) {
  const minRequireModalStyle = {
    width: '560px',
    left: 'calc(50vw - 280px)',
    top: '30%',
  };
  const clusterSaveModalStyle = {
    width: '33%',
    height: 'auto',
    left: '36%',
    top: '15%',
  };
  const [minReqiureModal, setMinReqiureModal] = useState(props.minReqiureModal);
  const { project, selectedCluster, clusterSegmentCount } = props;
  const [clusterSaveModal, setClusterSaveModal] = useState(props.clusterSaveModal);
  const [solutionName, setSolutionName] = useState(props.solutionName);
  const [errorFlag, setErrorFlag] = useState(true);
  const [emptyNameFlag, setEmptyNameFlag] = useState(false);
  const { userId, currentAccountId } = useSelector(state => state.login.loginResponse.data);
  const { projectId, chartView } = props.project;

  const {
    thresholds,
    setThresholds,
    scatOp,
    setScatOp,
    cellSize,
    setCellSize,
    bandWidth,
    setBandWidth,
    interval,
    setInterval,
    clustersVisible,
    setClustersVisible,
  } = props;

  const dispatch = useDispatch();
  const toggleCollapsibleDropdown = (keyType, activeProjectId) => {
    dispatch(cacActions.toggleCollapsibleDropdown(keyType, activeProjectId));
  };

  const setChartView = chartView => {
    dispatch(cacActions.setCacChartView(projectId, chartView));
  };

  const addToPassive = (keyType, activeProjectId, index, isPassive) => {
    const gridData = keyType === 'row' ? props.project.rows : props.project.columns;
    const gridFilterData = _.filter(gridData, item => item.isShow === true);
    const passives = keyType === 'row' ? props.project.passiveRows : props.project.passiveCols;
    if (gridFilterData.length - passives.length > 3 || isPassive) {
      dispatch(cacActions.addToPassive(keyType, activeProjectId, index));
      const projectObj = getApiRequestParameter(props.project, keyType, index, ADD_TO_PASSIVE_EVENT);
      dispatch(cacActions.getCACProjectDetails({ userId, currentAccountId, ...projectObj }));
      dispatch(cacActions.getClusterProjectDetails({ userId, currentAccountId, ...projectObj }));
    } else {
      setMinReqiureModal(true);
    }
  };

  const showHideDataPoint = (keyType, activeProjectId, index, isShow) => {
    const gridData = keyType === 'row' ? props.project.rows : props.project.columns;
    const gridFilterData = _.filter(gridData, item => item.isShow === true);
    const passives = keyType === 'row' ? props.project.passiveRows : props.project.passiveCols;
    if (gridFilterData.length - passives.length > 3 || isShow) {
      dispatch(cacActions.showHideDataPoint(keyType, activeProjectId, index));
      const projectObj = getApiRequestParameter(props.project, keyType, index, SHOW_HIDE_DATAPOINT_EVENT);
      dispatch(cacActions.getCACProjectDetails({ userId, currentAccountId, ...projectObj }));
      dispatch(cacActions.getClusterProjectDetails({ userId, currentAccountId, ...projectObj }));
    } else {
      setMinReqiureModal(true);
    }
  };

  const setClusterSegmentCount = (activeProjectId, segmentCount) => {
    dispatch(cacActions.updateClusterSegmentCount(activeProjectId, segmentCount));
  };

  const setSelectedCluster = (activeProjectId, selectedCluster, segmentCount, keyType) => {
    dispatch(
      cacActions.setSelectedCluster(
        activeProjectId,
        selectedCluster,
        segmentCount
      )
    );
    const projectObj = getApiRequestParameter(
      props.project,
      keyType,
      segmentCount, // index
      HANDLE_CHANGE_CLUSTER_SIZE
    );
    dispatch(
      cacActions.getCACProjectContourMap({
        userId,
        currentAccountId,
        ...projectObj,
      })
    ); // jed
  };;

  const handleClusterBySwitch = val => {
    const projectObj = getApiRequestParameter(
      props.project,
      val,
      '',
      HANDLE_CLUSTER_BY_SWITCH_EVENT
    );
    dispatch(cacActions.handleClusterBySwitch(val));
    dispatch(
      cacActions.getClusterProjectDetails({
        userId,
        currentAccountId,
        ...projectObj,
      })
    );
  };;

  const saveClusterSolution = () => {
    if(solutionName.trim().length > 0){
    const segmentNames = project.clusterResponse.solutions[selectedCluster]
      .segments.map(segment => segment.segmentName);
    dispatch(cacActions.saveClusterSolution({ userId,
      currentAccountId, solutionName, segmentNames,  ...project })).then(res => {
        setErrorFlag(res.status);
        if(res.status) {
          setSolutionName(props.solutionName);
          setClusterSaveModal(false)
        }
      })
    } else {
      setEmptyNameFlag(true);
    }
  };

  const enableInDevOnly = () => {
      const local =
        window.location.hostname === 'local.dev.insights.mrisimmons' ||
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname === '' ||
        window.location.hostname === 'dev.insights.mrisimmons' ||
        window.location.hostname === 'qa1.insights.mrisimmons';
      if (local) return true;
      return  process.env.NODE_ENV === 'development';
  };

  return (
    <div
      className="view-left-content"
      data-test="ClusterLeftContentGridComponent"
    >
      <CacGridData
        data-test="cacGridDataComp"
        project={project}
        toggleCollapsibleDropdown={toggleCollapsibleDropdown}
        addToPassive={addToPassive}
        showHideDataPoint={showHideDataPoint}
      />
      <ClusterRespondentsBlock
        data-test="clusterRespondentBlockComp"
        checkedValue={project.clusterBy === 'cols' ? 0 : 1}
        handleClusterBySwitch={handleClusterBySwitch}
      />
      <CacSwitchPanel mapView={project.clusterMapView} aType="cluster" />
      <CorrAxisSelectBlock
        activeProjectId={projectId}
        chartView={chartView}
        setChartView={setChartView}
      />
      <ClusterModelPerfBlock
        project={project}
        projectData={project.clusterResponse ? project.clusterResponse : {}}
        clusterSegmentCount={clusterSegmentCount}
        setClusterSegmentCount={setClusterSegmentCount}
        selectedCluster={selectedCluster}
        setSelectedCluster={setSelectedCluster}
        clustersVisible={clustersVisible}
        setClustersVisible={setClustersVisible}
      />
      <button
        type="button"
        onClick={() => setClusterSaveModal(true)}
        className="save-solution-btn"
      >
        {SAVE_SOLUTION_BTN_TITLE}
      </button>

      {enableInDevOnly() && project.clusterMapView && (
        <TempClusterControlPanel
          thresholds={thresholds}
          setThresholds={setThresholds}
          cellSize={cellSize}
          setCellSize={setCellSize}
          bandWidth={bandWidth}
          setBandWidth={setBandWidth}
          scatOp={scatOp}
          setScatOp={setScatOp}
          interval={interval}
          setInterval={setInterval}
        />
      )}
      <PortalModal
        isShowing={minReqiureModal}
        hide={() => setMinReqiureModal(false)}
        title={CAC_MODULE_TITLE}
        dialogStyles={minRequireModalStyle}
        onCloseClicked={() => setMinReqiureModal(false)}
      >
        <div>{INSUFFICIENT_DATA_MODAL_TEXT.split('|')[0]}</div>
        <div style={{ paddingBottom: '15px' }}>
          {INSUFFICIENT_DATA_MODAL_TEXT.split('|')[1]}
        </div>
        <div className="text-center">
          <GenericButton
            name="Ok"
            onBtnClick={() => setMinReqiureModal(false)}
          />
        </div>
      </PortalModal>
      <PortalModal
        isShowing={clusterSaveModal}
        title="Save as"
        onCloseClicked={() => {
          setErrorFlag(true);
          setEmptyNameFlag(false);
          setSolutionName('');
          setClusterSaveModal(false);
        }}
        dialogStyles={clusterSaveModalStyle}
      >
        <p>{CAC_CLUSTER_SAVE_POPUP_TITLE}</p>
        <div className="row crossTabNameModal padding-left-10 save-as-modal">
          <input
            type="text"
            placeholder={CAC_CLUSTER_SAVE_POPUP_TITLE}
            className="display-inline width-200"
            onChange={e => {
              if (e.target.value.length === 0 || e.target.value.trim()) {
                setEmptyNameFlag(false);
                setErrorFlag(true);
                setSolutionName(e.target.value);
              }
            }}
          />
          <GenericButton
            name="OK"
            btnStyle="button btn-cncl save-as-modal-save"
            onBtnClick={() => {
              saveClusterSolution();
            }}
          />
          <GenericButton
            name="Cancel"
            btnStyle="button save-as-modal-save-as"
            onBtnClick={() => {
              setErrorFlag(true);
              setSolutionName('');
              setClusterSaveModal(false);
              setEmptyNameFlag(false);
            }}
          />
        </div>
        {!errorFlag && (
          <div className="row crossTabNameModal padding-left-10 error-text">
            {CAC_CLUSTER_ALREADY_USED_NAME}
          </div>
        )}
        {emptyNameFlag && (
          <div className="row crossTabNameModal padding-left-10 error-text">
            {CAC_CLUSTER_EMPTY_NAME}
          </div>
        )}
      </PortalModal>
    </div>
  );
}

ClusterLeftContentGrid.defaultProps = {
  minReqiureModal: false,
  clusterSaveModal: false,
  solutionName: '',
};

ClusterLeftContentGrid.propTypes = {
  project: PropTypes.shape({
    clusterMapView: PropTypes.bool,
    study: PropTypes.instanceOf(Object),
    rows: PropTypes.arrayOf(PropTypes.object),
    columns: PropTypes.arrayOf(PropTypes.object),
    base: PropTypes.arrayOf(PropTypes.object),
    isBaseOpen: PropTypes.bool,
    isRowsOpen: PropTypes.bool,
    isColumnsOpen: PropTypes.bool,
    isPassivesOpen: PropTypes.bool,
    projectId: PropTypes.number,
    corrMapView: PropTypes.bool,
    chartView: PropTypes.instanceOf(Array),
    passiveRows: PropTypes.arrayOf(PropTypes.number),
    passiveCols: PropTypes.arrayOf(PropTypes.number),
    corrResponse: PropTypes.shape({
      cm: PropTypes.instanceOf(Object),
    }),
    clusterResponse: PropTypes.instanceOf(Object),
    clusterBy: PropTypes.string,
  }),
  selectedCluster: PropTypes.number,
  clusterSegmentCount: PropTypes.number,
  minReqiureModal: PropTypes.bool,
  clusterSaveModal: PropTypes.bool,
  solutionName: PropTypes.string,
  bandWidth: PropTypes.number,
  setBandWidth: PropTypes.func,
  thresholds: PropTypes.number,
  setThresholds: PropTypes.func,
  scatOp: PropTypes.number,
  setScatOp: PropTypes.func,
  cellSize: PropTypes.number,
  setCellSize: PropTypes.func,
  interval: PropTypes.number,
  setInterval: PropTypes.func,
  clustersVisible: PropTypes.arrayOf(PropTypes.bool),
  setClustersVisible: PropTypes.func,
};

export default ClusterLeftContentGrid;
